var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTemperature(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 19,
    viewBox: "0 0 9 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.35239 2.21484H7.24121V2.53878H8.35239V2.21484Z",
    fill: "#6DBFFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.99756 2.91602H7.23828V3.23995H8.99756V2.91602Z",
    fill: "#6DBFFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.35044 3.61523H7.23926V3.93917H8.35044V3.61523Z",
    fill: "#6DBFFF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.34946 4.31055H7.23828V4.63448H8.34946V4.31055Z",
    fill: "#6DBFFF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.99952 5.01562H7.24023V5.33956H8.99952V5.01562Z",
    fill: "#6DBFFF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M8.35239 5.71484H7.24121V6.03878H8.35239V5.71484Z",
    fill: "#6DBFFF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M8.35142 6.41406H7.24023V6.738H8.35142V6.41406Z",
    fill: "#6DBFFF"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M8.99854 7.11328H7.23926V7.43722H8.99854V7.11328Z",
    fill: "#6DBFFF"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M8.35239 7.81641H7.24121V8.14034H8.35239V7.81641Z",
    fill: "#6DBFFF"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M8.35239 8.51953H7.24121V8.84347H8.35239V8.51953Z",
    fill: "#6DBFFF"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M8.99854 9.21484H7.23926V9.53878H8.99854V9.21484Z",
    fill: "#6DBFFF"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M4.46854 16.2242C5.73749 16.2242 6.76618 15.1955 6.76618 13.9265C6.76618 12.6576 5.73749 11.6289 4.46854 11.6289C3.19959 11.6289 2.1709 12.6576 2.1709 13.9265C2.1709 15.1955 3.19959 16.2242 4.46854 16.2242Z",
    fill: "#6DBFFF"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M6.79554 10.1055V2.32463C6.79554 1.04274 5.75265 0 4.47076 0C3.18887 0 2.14598 1.04274 2.14598 2.32463V10.1055C0.817935 10.9155 0 12.3633 0 13.9242C0 16.3894 2.00561 18.3949 4.47076 18.3949C6.93601 18.3949 8.94167 16.3895 8.94167 13.9242C8.94167 12.3633 8.12362 10.9155 6.79554 10.1055ZM4.47076 16.7967C2.88688 16.7967 1.59835 15.5081 1.59835 13.9242C1.59835 12.4373 2.73388 11.2109 4.18331 11.0662V2.03608H4.75816V11.0662C6.20759 11.2109 7.34324 12.4373 7.34324 13.9242C7.34328 15.5081 6.05467 16.7967 4.47076 16.7967Z",
    fill: "#6DBFFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTemperature);
export default __webpack_public_path__ + "static/media/temperature.c6aaf51085893ab5999e7054e8421df3.svg";
export { ForwardRef as ReactComponent };